import ChakraProvider from "@pathwright/ux/src/components/chakra/ChakraProvider"
import { SpaceFragment } from "@pathwright/graphql-client/src/generated"
import { useSpaceContext } from "../../views/space/api/context"

// NOTE: we aren't currently using the overlayText, but leaving for reference,
// since we may wish to in the future.
const getSystemConfig = (space: SpaceFragment) => {
  const overlayText = space.theme!.background!.contrast_color || "white"

  return {
    colors: {
      overlayText
    }
  }
}

const ThemeProvider = ({ children }: { children: JSX.Element }) => {
  const { space } = useSpaceContext()

  return (
    <ChakraProvider brandColorPalette={space.theme.color_palette}>
      {children}
    </ChakraProvider>
  )
}

export default ThemeProvider
